import config from '../../config.json'

const headers = () => ({
  'Content-Type': 'application/json',
  token: config.token,
})

export async function fetchUnreadCount() {
  const res = await fetch(`${config.apiUrl}/notifications/unread-count`, {
    method: 'GET',
    headers: headers(),
  })
  return res.json()
}

export async function fetchRecentNotifications(limit = 6) {
  const res = await fetch(`${config.apiUrl}/notifications/recent?limit=${limit}`, {
    method: 'GET',
    headers: headers(),
  })
  return res.json()
}

export async function fetchNotifications(page = 1, itemsPerPage = config.defaultItemsPerPage) {
  if (!config.apiUrl || !config.token) {
    return { status: 'error', msg: 'Sesión no disponible para cargar notificaciones' }
  }

  const res = await fetch(
    `${config.apiUrl}/notifications?page=${page}&itemsPerPage=${itemsPerPage}`,
    {
      method: 'GET',
      headers: headers(),
    }
  )
  return res.json()
}

export async function markNotificationRead(notificationId) {
  const res = await fetch(`${config.apiUrl}/notifications/${notificationId}/read`, {
    method: 'POST',
    headers: headers(),
  })
  return res.json()
}

export async function markAllNotificationsRead() {
  const res = await fetch(`${config.apiUrl}/notifications/read-all`, {
    method: 'POST',
    headers: headers(),
  })
  return res.json()
}

export function formatNotificationDate(value) {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
